import { useEffect, useMemo } from "react";
import { Outlet, useLocation, useNavigate, NavLink } from "react-router-dom";
import { Tabs } from "@/components";
import { SpaceWrapper } from "../../components";

const Settings = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/settings") {
      navigate("/settings/kyc", { replace: true }); // Prevents unnecessary history entries
    }
  }, [location.pathname, navigate]);

  const tabs = useMemo(
    () => [
      { label: "KYC", link: "kyc" },
      { label: "Channel", link: "channel" },
      { label: "Label Settings", link: "labelSettings" },
      { label: "Employee Login", link: "employeeLogin" },
      { label: "Courier Mgmt.", link: "courierMgmt" },
      { label: "Pickup Address", link: "pickupAddress" },
      { label: "Shipping ID", link: "shippingId" },
    ],
    []
  );

  return (
    <div className="w-full flex-1 flex flex-col pb-20 md:pb-4 relative max-w-[2000px]">
      <Tabs tabs={tabs} NavLink={NavLink} />
      <Outlet />
    </div>
  );
};

export default Settings;
